import api from "services/api";
import { CriterionClassDisciplineList, CriterionClassDisciplineDetail, CriterionClassDisciplineForm } from "./types";


const PREFIX = 'activities';

type ListQueryParams = {
    search?: string;
    clss?: number;
    discipline?: number;
    criterion?: number;
}

type CriterionClassDisciplineListResponse = {
    results: CriterionClassDisciplineList[]
}


class CriterionClassDisciplineService {

    endpoint: string;

    constructor() {
        this.endpoint = 'criterions_class_discipline';
    }

    list = async (params: ListQueryParams): Promise<CriterionClassDisciplineListResponse> => {
        const { data } = await api.get<CriterionClassDisciplineListResponse>(`${PREFIX}/${this.endpoint}`, { params })
        return data
    }

    get = async (criterionClassDisciplineId: number): Promise<CriterionClassDisciplineDetail> => {
        const criterionClassDiscipline = await api.get<CriterionClassDisciplineDetail>(`${PREFIX}/${this.endpoint}/${criterionClassDisciplineId}`)
        return criterionClassDiscipline.data
    }

    create = async (payload: CriterionClassDisciplineForm) => {
        const { data } = await api.post(`${PREFIX}/${this.endpoint}`, payload)
        return data
    }

    update = async (id: number, payload: CriterionClassDisciplineForm) => {
        const { data } = await api.patch(`${PREFIX}/${this.endpoint}/${id}`, payload)
        return data
    }

    // delete = async (id: number) => (
    //     api.delete(`${PREFIX}/${this.endpoint}/${id}`)
    // )
}

const service = new CriterionClassDisciplineService()

export default service
